import columns from '../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    ExternalReceptacleLinkColumn,
  } = columns(data);

  return [
    {
      Header: 'Receptacle',
      columns: [
        new ExternalReceptacleLinkColumn(new TextColumn('Receptacle ID', 'receptacle.receptacleId').withWidth(275)),
        new TextColumn('Destination IMPC', 'receptacle.destinationImpc'),
      ],
    },
    {
      Header: 'MRD POD',
      columns: [
        new DateTimeColumn('Event date', 'mrdPod.eventDate'),
        new TextColumn('Carrier', 'mrdPod.carrier'),
        new TextColumn('Conveyance reference', 'mrdPod.conveyanceReference'),
        new TextColumn('Handler', 'mrdPod.handler'),
      ],
    },
    {
      Header: 'RESCON',
      columns: [
        new DateTimeColumn('Event date', 'rescon.eventDate'),
        new TextColumn('Location', 'rescon.location'),
      ],
    },
    {
      Header: 'RESDES',
      columns: [
        new DateTimeColumn('Event date', 'resdes.eventDate'),
      ],
    },
  ];
};
